import React, {Component} from 'react';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('TRANSMISSION_STATUS_PROPERTY_FILTER', LOG_LEVELS.DEBUG);

class TransmissionStatusPropertyFilter extends Component {

    constructor(props) {
        super(props);
        this.handleChangeLegalEntity = this.handleChangeLegalEntity.bind(this);
        this.handleChangeInvocieNumber = this.handleChangeInvocieNumber.bind(this);
    }

    handleChangeLegalEntity(event) {
        log.debug('handleChangeLegalEntity(%s): %s, ', 'legalEntity', event.target.value);
        let selection = {
            legalEntity: event.target.value
        };
        this.props.selectionHandler(selection);
    }

    handleChangeInvocieNumber(event) {
        this.setState({invoiceNumber: event.target.value});
        log.debug('handleChangeInvocieNumber(%s): %s, ', 'invoiceNumber', event.target.value);
        let selection = {
            invoiceNumber: event.target.value
        };
        this.props.selectionHandler(selection);
    }

    render() {
        log.debug("render(): ", this.props);
        return (
            <div>
                <fieldset>
                    <label><LanguageStringResolver string='transmissionStatusFilterPanel_LegalEntity'/></label>
                    <input value={this.props.legalEntity} onChange={this.handleChangeLegalEntity}/>
                </fieldset>
                <fieldset>
                    <label><LanguageStringResolver string='transmissionStatusFilterPanel_InvoiceNumber'/></label>
                    <input value={this.props.invoiceNumber} onChange={this.handleChangeInvocieNumber}/>
                </fieldset>
            </div>
        );
    }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


// Wrap the component to inject state into it
export default connect(mapStateToProps)(TransmissionStatusPropertyFilter);
